import axios from "axios";

export default {
    namespaced: true,
    state: {
        gatewayInfo: null,
        giftCardData: {
            purchaser: {
                user_id: null,
                guest_id: null
            },
            payment: {
                card_number: null,
                credit_card_id: null,
                gateway_id: null,
                business_id: null
            },
            cards: [],
            contact_info: {
                email: null,
                name: null,
                phone: null
            },
            my_wallet: false
        }
    },
    mutations: {
        addGiftCard(state,val){
            state.giftCardData.cards.push(val);
            if (!state.giftCardData.subTotal) {
                state.giftCardData.subTotal = subTotal.bind(state.giftCardData);
            }
        },
        updateGiftCard(state,val){
            state.giftCardData.cards.splice(val.index, 1, val.item)
        },
        setPaymentInfo(state,val){
            state.giftCardData.payment = val;
        },
        removeGiftCard(state,index){
            state.giftCardData.cards.splice(index, 1);
        },
        setContactInfo(state,val){
            state.giftCardData.contact_info = val;
        },
        resetGcart(state){
            state.giftCardData.purchaser.user_id = null;
            state.giftCardData.purchaser.guest_id = null;
            state.giftCardData.payment.card_number = null;
            state.giftCardData.payment.credit_card_id = null;
            state.giftCardData.payment.gateway_id = null;
            state.giftCardData.payment.business_id = null;
            state.giftCardData.cards = [];
            state.giftCardData.contact_info.email = null;
            state.giftCardData.contact_info.name = null;
            state.giftCardData.contact_info.phone = null;
            state.giftCardData.my_wallet = false;
        }
    },
    actions:{
        getGiftCardsList(store,{callback}){
            const group_id = store.rootState.shared.groupId;
            axios.get(`/unauth/groups/${group_id}/gift_card_types?all_themes=1&source=2`).then(res => {
                if (callback) {
                    callback(res);
                }
            });
        },
        buyGiftCards(store,{data,callback} = {}){
            data = data ?? store.state.giftCardData;
            if(data.purchaser.user_id){
                data.purchaser.guest_id = null;
            }
            //console.log(JSON.stringify(data, null, "\t"))
            axios.post(`/unauth/purchase_gift_card`,data).then(res => {
                callback?.();
            }).catch(error => {
                store.commit("shared/setAlert", `<h5>${error.response.data}</h5>`,{root: true})
            });
        },
        buyForMyselfGiftCard(store,{data,callback} = {}){
            const member_id = store.rootState.user.user.member_id;
            data = data ?? store.state.giftCardData;
            data = {
                "amount": data.cards[0].amount,
                "payment_method" : 'credit_card',
                "gift_card_type_id": data.cards[0].type_id,
                "payment_data": data.payment.credit_card_id
            }
            axios.post(`/auth/users/${member_id}/gift_cards`,data).then(res => {
                callback?.();
            }).catch(error => {
                store.commit("shared/setAlert", `<h5>${error.response.data}</h5>`,{root: true})
            });
        },
        linkGiftToUser(store,{data,callback}){
            const member_id = store.rootState.user.user.member_id;
            axios.put(`/auth/users/${member_id}/gift_cards`,data).then(res => {
                if (callback) {
                    callback(res);
                }
            }).catch(error => {
                store.commit("shared/setAlert", `<h5>${error.response.data}</h5>`,{root: true})
            })
        },
        linkGiftToGuestUser(store,{data,callback}){
            axios.get(`https://ccp.mobileappsuite.com/kiosk/get_gift_cards_history/5ff733db9271f?card_number=${data.giftCardNumber}&cvv=${data.cvv}`).then(res =>{
                if (callback) {
                    callback(res);
                }
            }).catch(error => {
                console.log(error)
                const msg = error.response ? error.response.data : "Error";
                store.commit("shared/setAlert", `<h5>${msg}</h5>`,{root: true})
            });
        },
        deleteGiftCard(store,{id,callback}){
            const member_id = store.rootState.user.user.member_id;
            axios.delete(`/auth/users/${member_id}/gift_cards/${id}`).then(res => {
               callback?.();
            }).catch(error => {
                store.commit("shared/setAlert", `<h5>${error.response.data}</h5>`,{root: true})
            })
        },
        refillGiftCard(store,{data,callback}){
            const member_id = store.rootState.user.user?.member_id;
            axios.put(`/auth/users/${member_id}/gift_cards/${data?.gift_card_id}`,data).then(res => {
                callback?.();
            }).catch(error => {
                store.commit("shared/setAlert", `<h5>${error.response.data}</h5>`,{root: true})
            });
        }
    }
}

const subTotal = function (){
    let total = 0;
    this.cards.map(el => { total += parseFloat(el.amount)} );
    return total.toFixed(2);
};
